export const DEFAULT_PAGE_SIZE = 60;
export const DEFAULT_PAGE_SIZE_OPTIONS = [60, 90, 120, 180, 360];
